import storeModule from '../store-module'
import { defineStore } from 'pinia'

const url = 'base-changes/approvals'

export default defineStore(
  'base-changes-approvals',
  storeModule.createStoreModule('base-changes-approvals', {
    fetchListURL: url,
    fetchSingleURL: url,
    fetchFiltersURL: `${url}/filters`,
    updateURL: ({ id }) => `${url}/${id}`
  })
)
